import React from 'react';
import Icon from '../../../components/AppIcon';

const UserTypeCard = ({ 
  id, 
  label, 
  description, 
  icon, 
  isSelected, 
  onSelect 
}) => {
  return (
    <button
      onClick={() => onSelect(id)}
      className={`
        w-full flex flex-col items-start p-6 md:p-8 lg:p-10 rounded-xl md:rounded-2xl
        border-2 min-h-[160px] md:min-h-[180px] lg:min-h-[200px]
        transition-all duration-300 ease-out
        transform hover:scale-[1.02] active:scale-[0.97]
        ${isSelected 
          ? 'border-primary bg-primary/5 shadow-therapeutic-md ring-2 ring-primary/20 ring-offset-2 ring-offset-background scale-[1.01]' 
          : 'border-border bg-card hover:border-primary/60 hover:shadow-therapeutic hover:bg-primary/[0.02]'
        }
        focus:outline-none focus:ring-3 focus:ring-ring focus:ring-offset-2 focus:ring-offset-background
      `}
      aria-pressed={isSelected}
      aria-label={`Select ${label} user type`}
    >
      <div className={`
        flex items-center justify-center w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 
        rounded-lg md:rounded-xl mb-4 md:mb-5 lg:mb-6
        transition-all duration-300 ease-out
        ${isSelected 
          ? 'bg-primary text-primary-foreground shadow-md scale-110' 
          : 'bg-muted text-muted-foreground group-hover:bg-primary/10'
        }
      `}>
        <Icon 
          name={icon} 
          size={24} 
          strokeWidth={isSelected ? 2.5 : 2} 
        />
      </div>
      
      <h3 className={`
        text-lg md:text-xl lg:text-2xl font-heading font-semibold mb-2 md:mb-3
        transition-colors duration-200
        ${isSelected ? 'text-primary' : 'text-foreground'}
      `}>
        {label}
      </h3>
      
      <p className="text-sm md:text-base lg:text-lg text-muted-foreground text-left leading-relaxed">
        {description}
      </p>
      
      <div className={`
        mt-auto pt-4 md:pt-5 flex items-center gap-2
        transition-all duration-300 ease-out
        ${isSelected ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-1 pointer-events-none'}
      `}>
        <div className="animate-in zoom-in-50 duration-200">
          <Icon 
            name="CheckCircle2" 
            size={20} 
            color="var(--color-primary)" 
            strokeWidth={2.5} 
          />
        </div>
        <span className="text-xs font-semibold text-primary">Selected</span>
      </div>
    </button>
  );
};

export default UserTypeCard;